import React, { useEffect, useState } from "react";
import "../../styles/users.scss";
import { PlayersTable } from "../../components/players/PlayersTable";
import { PlayerDetails } from "../../components/players/PlayerDetails";
import { useSeasonsStore } from "../../store/seasonsStore";
import { usePlayersStore } from "../../store/playersStore";
import { Busy } from "../../components/Busy";

const Players: React.FC<any> = () => {
  const { currentSeason } = useSeasonsStore();
  const { players, isBusy, busyMessage, getPlayers } = usePlayersStore();
  const [filteredPlayers, setFilteredPlayers] = useState<any>([]);

  const [currentPlayer, setCurrentPlayer] = useState(null);
  const [search, setSearch] = useState("");
  useEffect(() => {
    if (search) {
      setFilteredPlayers(
        players
          ? players.filter(
              (player: any) =>
                player.firstName.toLowerCase().includes(search.toLowerCase()) ||
                player.lastName.toLowerCase().includes(search.toLowerCase())
            )
          : []
      );
    } else {
      setFilteredPlayers(players);
    }
  }, [search, players]);

  const showPlayerDetails = (player: any) => {
    setCurrentPlayer(player);
  };

  useEffect(() => {
    if (currentSeason) {
      getPlayers(currentSeason.id);
    }
  }, [currentSeason]);
  return (
    <>
      <div className="pt-2 bg-opacity-70 bg-gray-100 dark:bg-gray-800 dark:bg-opacity-50">
        {!currentPlayer && (
          <>
            <div className="sm:flex sm:items-center gap-2">
                <h1 className="text-base font-semibold leading-4 text-gray-900 dark:text-white">
                  Season Players
                </h1>
                <p className="mt-1 text-sm text-gray-700 dark:text-gray-200">
                  A list of all the players in this season.
                </p>
            </div>

            <PlayersTable
              players={filteredPlayers}
              selectPlayer={showPlayerDetails}
              setSearch={setSearch}
            />
          </>
        )}
        {currentPlayer && (
          <PlayerDetails
            player={currentPlayer}
            selectPlayer={() => setCurrentPlayer(null)}
          />
        )}
      </div>
      {isBusy && (
        <Busy busyMessage={busyMessage ? busyMessage : "Please wait..."} />
      )}
    </>
  );
};

export default Players;
